module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('emt-form', {
    ref: "area-form",
    attrs: {
      "resource": _vm.config.api + '/area/',
      "items": _vm.itemsForm,
      "updateData": _vm.update
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titlle_div"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("Editar área")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b63ce72"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/emt-form-edit-area.vue
// module id = 156
// module chunks = 0